export default function sanitizeString(
  dirty: string,
  blackListRegex: RegExp = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g
) {
  return dirty.replace(blackListRegex, '');
}
